import { render, staticRenderFns } from "./FormationsManager.vue?vue&type=template&id=3adb8c74&"
import script from "./FormationsManager.vue?vue&type=script&lang=js&"
export * from "./FormationsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports